"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  MIT: "https://opensource.org/licenses/MIT",
  "EPL-1.0": "https://opensource.org/licenses/EPL-1.0",
  "CDDL-1.0": "https://opensource.org/licenses/CDDL-1.0",
  "MPL-2.0": "https://opensource.org/licenses/MPL-2.0",
  LGPL: "https://opensource.org/licenses/lgpl-license",
  GPLv2: "https://opensource.org/licenses/GPL-2.0",
  GPLv3: "https://opensource.org/licenses/GPL-3.0",
  "Apache-2.0": "https://opensource.org/licenses/Apache-2.0",
  "BSD 2 Clause": "https://opensource.org/licenses/BSD-2-Clause",
  "BSD 3 Clause": "https://opensource.org/licenses/BSD-3-Clause"
};